import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { LicenseExpiredModalComponent } from "../license-expired-modal/license-expired-modal.component";
import { Location } from "@angular/common";
import { ROUTES } from "./sidebar-routes.config";
import { Router, ActivatedRoute } from "@angular/router";
import { HelperService } from "../services/helper.service";
import { ScanhistoryService } from "@app/superadmin/services/scanhistory/scanhistory.service";
import { saveAs } from "file-saver";
import moment from "moment";
import { ToastrService } from "ngx-toastr";
declare var $: any;

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
})
export class SidebarComponent implements OnInit {
  public menuItems: any[] = [];
  public tempmenuItems: any[];
  public tempNavControl = true;
  public permissions: any[] = [];
  public environment: string;
  public userType: string;
  public scanDataDownloadInProgress = null;
  constructor(
    private router: Router,
    public helperService: HelperService,
    public location: Location,
    private scanService: ScanhistoryService,
    private tostr: ToastrService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    $.getScript("./assets/js/app-sidebar.js");
    // tslint:disable-next-line: no-string-literal
    this.userType = this.helperService.getUserType();
    // console.log('userType', this.userType);
    // tslint:disable-next-line: no-string-literal
    this.environment = this.location["_platformLocation"].location.hostname;
    this.menuItems = ROUTES.filter((menuItem) => menuItem);

    console.log({ menuItmes: this.menuItems });

    if (this.menuItems.length && this.menuItems[0].title === "Dashboard") {
      this.menuItems[0].childpath = this.helperService.IsAgnextAdmin()
        ? "/dashboard/home"
        : "/dashboard/landing";
      if (this.menuItems[0].submenu && this.menuItems[0].submenu.length) {
        this.menuItems[0].submenu[0].path = this.helperService.IsAgnextAdmin()
          ? "/dashboard/home"
          : "/dashboard/landing";
      }
    }

    if (this.helperService.IsClient()) {
      // console.log({'this.menuItems1299999':this.menuItems});
      // this.menuItems.length=2;
      this.menuItems = [];
    }

    if (this.helperService.IsAgnextAdmin()) {
      // console.log({'this.menuItems1299999':this.menuItems});
      // this.menuItems.length=2;

      this.menuItems.shift(); // Remove Dashboard link for now
    }

    this.permissions = this.helperService.permission.get();

    console.log({ menuItmes: this.menuItems });

    this.menuItems.forEach((mi) => {
      // Custom logic for Dish Details menu item
      if (mi.title === "Dish Details") {
        const isCustomerAdmin =
          this.helperService.getUserType() === "customer_admin";
        const isFW =
          this.helperService.getProductType &&
          this.helperService.getProductType() === "fw";
        mi.accessPermission = isCustomerAdmin && isFW;
        return;
      }
      // Custom logic for Dashboard - show for customer admins, and for the
      // specific operator logins that already have a site dashboard built
      // (currently just cgi.op2@agnext.in -- the rest are TBD).
      if (mi.title === "Dashboard" && mi.path === "/dashboard/grafana") {
        const isCustomerAdmin = this.helperService.IsCustomerAdmin();
        const isOperator = this.helperService.getLoggedInUserRole().some((r) => r === 'operator');
        const userEmail = (this.helperService.getUserEmail() || '').toLowerCase();
        const enabledOperatorEmails = ['cgi.op2@agnext.in'];
        const isEnabledOperator = isOperator && enabledOperatorEmails.includes(userEmail);
        const productType = this.helperService.getProductType();
        const shouldShow = (isCustomerAdmin || isEnabledOperator) && productType === 'icompass';
        console.log('Dashboard - Is Customer Admin:', isCustomerAdmin);
        console.log('Dashboard - Is Enabled Operator:', isEnabledOperator);
        console.log('Dashboard - Product Type:', productType);
        console.log('Dashboard - Should Show:', shouldShow);
        mi.accessPermission = shouldShow;
        return;
      }
      // Custom logic for Tea Analysis - show for all tea product type clients
      if (mi.title === "Tea Analysis" && mi.path === "/dashboard/tea-analysis") {
        const isCustomerAdmin = this.helperService.IsCustomerAdmin();
        const productType = this.helperService.getProductType();
        // const isTeaClient = productType === 'tea';
        const isTeaClient = this.helperService.getCustomerId() == 364;
        console.log('Tea Analysis - Product Type:', productType, 'Is Tea Client:', isTeaClient, 'Is Customer Admin:', isCustomerAdmin);
        mi.accessPermission = isCustomerAdmin && isTeaClient;
        return;
      }
      // console.log('menuItems', mi.accessPermission);
      if (
        !mi.deniedPermission &&
        mi.accessPermission &&
        mi.accessPermission.find(
          (x) =>
            this.permissions.indexOf(x) > -1 || this.userType.indexOf(x) > -1
        )
      ) {
        mi.accessPermission = true;
      } else {
        mi.accessPermission = false;
      }

      mi.submenu.forEach((i) => {
        if (
          !i.deniedPermission &&
          i.accessPermission &&
          i.accessPermission.find(
            (x) =>
              this.permissions.indexOf(x) > -1 || this.userType.indexOf(x) > -1
          )
        ) {
          i.accessPermission = true;
        } else {
          i.accessPermission = false;
        }
      });
    });

    if (!this.helperService.IsAgnextAdmin()) {
      let adminPrimaryView = this.helperService.adminPrimaryView.get();
      
      // Preserve Dashboard menu item before any clearing operations (only if customer admin with icompass)
      const grafanaMenuItem = this.menuItems.find(mi => mi.title === "Dashboard" && mi.path === "/dashboard/grafana" && mi.accessPermission);
      
      // Preserve Tea Analysis menu item before any clearing operations
      const teaAnalysisMenuItem = this.menuItems.find(mi => mi.title === "Tea Analysis" && mi.path === "/dashboard/tea-analysis" && mi.accessPermission);

      if (!adminPrimaryView || adminPrimaryView == "LANDING") {
        this.menuItems = this.helperService.navigationRemoveMainMenu(
          this.menuItems,
          "Rake Board"
        );
        if (
          this.helperService.historytemplate.get() ==
          "SAMPLEIDCOMMODITYTRUCK_HISTORY_TEMPLATE"
        ) {
          this.menuItems = this.helperService.navigationRemovesubmenu(
            this.menuItems,
            "Dashboard",
            "Graphic View"
          );
        } else {
          this.menuItems = [];
        }
      } else if (adminPrimaryView == "TABLEU") {
        this.menuItems = this.helperService.navigationRemovesubmenu(
          this.menuItems,
          "Dashboard",
          "QC Scans"
        );
        this.menuItems = this.helperService.navigationRemoveMainMenu(
          this.menuItems,
          "Rake Board"
        );
        if (
          !this.helperService.IsCustomerAdmin() &&
          !this.helperService.IsAgnextAdmin()
        ) {
          this.menuItems = this.helperService.navigationRemoveMainMenu(
            this.menuItems,
            "Analytics"
          );
        }
      } else if (adminPrimaryView == "RAKE") {
        this.menuItems = this.helperService.navigationRemoveMainMenu(
          this.menuItems,
          "Dashboard"
        );
      } else {
        this.menuItems = [];
        // this.menuItems = this.helperService.manageNavigationsubmenu(this.menuItems,'Dashboard','QC Scans');
      }
      
      // Add Grafana menu item back if it was preserved and user is Compass
      if (grafanaMenuItem) {
        this.menuItems.push(grafanaMenuItem);
      }
      
      // Add Tea Analysis menu item back if it was preserved
      if (teaAnalysisMenuItem) {
        this.menuItems.push(teaAnalysisMenuItem);
      }
    }

    //Add Data Export Link
    if (this.helperService.exportPermission.get()) {
      if (this.helperService.IsAgnextCustomerAdmin()) {
        //Adding Export data link
        const itemtemp = {
          path: "",
          title: "Export",
          icon: "zmdi zmdi-download",
          class: "sub",
          badge: "",
          badgeClass: "",
          isExternalLink: false,
          submenu: [],
          accessPermission: true,
          childpath: "/dashboard/landing",
        };
        this.menuItems.push(itemtemp);
      }
    }

    if (this.helperService.IsCustomerAdmin()) {
      const deviceTrackingLink = {
        path: "/dashboard/device-operations",
        title: "Location Tracking",
        icon: "zmdi zmdi-map",
        class: "sub",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        accessPermission: ["customer_admin", "CUSTOMER"],
        childpath: "/dashboard/device-operations",
      };
      this.menuItems.push(deviceTrackingLink);
    }

    //Repor Generation Form Access
    if (
      (this.helperService.IsCustomerAdmin() ||
      this.helperService.IsNafedStateAdmin() ) && this.helperService.getProductType() !== 'tea'
    ) {
      const itemsupportlink = {
        path: "",
        title: "Generate Report",
        icon: "zmdi zmdi-download",
        class: "sub",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        accessPermission: true,
        childpath: "/dashboard/reporting",
      };
      this.menuItems.push(itemsupportlink);
    }
    const isKeyCloakLogin = this.helperService.keycloakSession?.get();
    if (!isKeyCloakLogin) {
      const changePasswordLink = {
        path: "/dashboard/change-password",
        title: "Change Password",
        icon: "zmdi zmdi-key",
        class: "sub",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
        accessPermission: true,
        childpath: "/dashboard/change-password",
      };
      this.menuItems.push(changePasswordLink);
    }
    // Add Dishes link if role is customer_admin and productType is fw
    const user = this.helperService.user.get(); // Get the full user object from localStorage
    const productType = this.helperService.getProductType(); // Get product type using updated logic

    // More detailed logs
    console.log(
      "Sidebar Debug - Full User Object from helperService.user.get():",
      JSON.stringify(user)
    );
    console.log(
      "Sidebar Debug - ProductType from helperService.getProductType():",
      productType
    );
    console.log(
      "Sidebar Debug - Raw LocalStorage product_type:",
      localStorage.getItem("product_type")
    );
    console.log(
      "Sidebar Debug - Raw LocalStorage user:",
      localStorage.getItem("user")
    );

    const hasCustomerAdminRole = user && user.roles && Array.isArray(user.roles) && user.roles.includes('customer_admin');
    const hasStateAdminRole = user && user.roles && Array.isArray(user.roles) && user.roles.includes('state_admin');
    const hasRegionHeadRole = user && user.roles && Array.isArray(user.roles) && user.roles.includes('region_head');
    console.log('Sidebar Debug - hasCustomerAdminRole:', hasCustomerAdminRole, 'Type:', typeof hasCustomerAdminRole);

    // Explicit type and value check for productType
    console.log(
      "Sidebar Debug - productType value:",
      "'" + productType + "'",
      "Type:",
      typeof productType
    );
    console.log(
      "Sidebar Debug - Comparison productType === 'fw':",
      productType === "fw"
    );
    console.log(
      "Sidebar Debug - Comparison productType == 'fw':",
      productType == "fw"
    ); // Loose comparison for sanity check
    console.log(
      "Sidebar Debug - productType.length (if string):",
      typeof productType === "string" ? productType.length : "Not a string"
    );
    console.log("Sidebar Debug - Hardcoded 'fw' === 'fw':", "fw" === "fw");

    if ((hasCustomerAdminRole || hasStateAdminRole || hasRegionHeadRole) && productType === 'fw') {
      console.log('Sidebar Debug: Conditions MET for Dishes link.');
      if(hasCustomerAdminRole){
        const dishDetailsLink = {
        path: '/dashboard/dish-details',
        title: 'Dishes',
        icon: 'zmdi zmdi-pizza',
        class: 'sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        accessPermission: true,
        childpath: "/dashboard/dish-details",
      };
      this.menuItems.push(dishDetailsLink);

      const counterDetailsLink = {
        path: '/dashboard/counter-details',
        title: 'Counters',
        icon: 'zmdi zmdi-case',
        class: 'sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        accessPermission: true,
        childpath: "/dashboard/counter-details",
      };
      this.menuItems.push(counterDetailsLink);
      }

      // Add Dish Analytics link immediately after Dishes if conditions are met
      console.log(
        "Sidebar Debug: Conditions MET for Dish Analytics link (same as Dishes)."
      );
      const dishAnalyticsLink = {
        path: '/dashboard/dish-analytics', // Route defined in dashboard-routing.module.ts
        title: 'Analytics',
        icon: 'zmdi zmdi-chart', // Material Icon name - template might need adjustment if using zmdi
        class: 'sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        accessPermission: true, 
        childpath: '/dashboard/dish-analytics' // Path for direct navigation
      };
      this.menuItems.push(dishAnalyticsLink);

      if(hasCustomerAdminRole){
        const itemConfig = {
            path: '/dashboard/item-config',
            title: 'Item Config',
            icon: 'zmdi zmdi-settings',
            class: 'sub',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
            accessPermission: true,
            childpath: '/dashboard/item-config'
        }
        this.menuItems.push(itemConfig);
    }

    } else {
      console.log('Sidebar Debug: Conditions NOT MET for Dishes link (and thus not for Dish Analytics).');
    }

    if (productType === 'fw' && this.helperService.getCustomerId() == 312) {
      const analyticsSummaryLink = {
        path: '/dashboard/analytics-summary',
        title: 'Analytics Summary',
        icon: 'zmdi zmdi-view-dashboard',
        class: 'sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        accessPermission: true,
        childpath: '/dashboard/analytics-summary',
      };
      this.menuItems.push(analyticsSummaryLink);
    }


    this.menuItems = this.menuItems.filter(
      (item) => item.title !== 'Source of Leaves' && item.title !== 'Reporting'
    );

    // Add Tea menu items (Source of Leaves and Reporting) when product type is 'tea'
    // Only for customer_admin role with product type 'tea'
    const isCustomerAdmin = this.helperService.IsCustomerAdmin();
    if (isCustomerAdmin && productType === 'tea') {
      console.log('Sidebar Debug: Conditions MET for Tea menu items.');
      const sourceOfLeavesLink = {
        path: '',
        title: 'Source of Leaves',
        icon: 'zmdi zmdi-coffee',
        class: 'sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [
          {
            path: '/dashboard/tea/estate',
            title: 'Estate',
            icon: 'fa fa-dot-circle-o',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
            accessPermission: true,
            childpath: '/dashboard/tea/estate'
          },
          {
            path: '/dashboard/tea/supplier',
            title: 'Supplier',
            icon: 'fa fa-dot-circle-o',
            class: '',
            badge: '',
            badgeClass: '',
            isExternalLink: false,
            submenu: [],
            accessPermission: true,
            childpath: '/dashboard/tea/supplier'
          }
        ],
        accessPermission: true,
        childpath: '/dashboard/tea/estate'
      };
      this.menuItems.push(sourceOfLeavesLink);

      const reportingLink = {
        path: '/dashboard/tea/reporting',
        title: 'Reporting',
        icon: 'zmdi zmdi-cloud',
        class: 'sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        accessPermission: true,
        childpath: '/dashboard/tea/reporting'
      };
      this.menuItems.push(reportingLink);
    }

    console.log("Menu Items after dynamic additions:", JSON.stringify(this.menuItems.map(item => item.title))); // Log only titles for brevity
  }

  public goToDashboard() {
    if (this.helperService.IsAgnextAdmin()) {
      // this.router.navigate(['dashboard/home']);
      this.router.navigate(["superadmin/customers"]);
    } else {
      if (this.helperService.isPermitted("shade_card_view")) {
        this.router.navigate(["visio/shadecard"]);
      } else {
        this.router.navigate(["dashboard/landing"]);
      }
    }
  }

  public goToChild($event, menu) {
    // License check: Only allow navigation to /dashboard/landing if expired
    if (this.helperService.isLicenseExpired()) {
      if (
        menu.childpath === "/dashboard/landing" ||
        menu.path === "/dashboard/landing"
      ) {
        this.router.navigate(["/dashboard/landing"]);
      } else {
        // Show license expired modal and block navigation
        this.dialog.open(LicenseExpiredModalComponent, {
          width: "400px",
          disableClose: true,
        });
      }
      return;
    }

    if (menu.childpath) {
      this.router.navigate([menu.childpath]);
      // event.stopPropagation();
    }

    // if (menu.title === 'Export') {
    // this.downloadScandata();
    // }

    if (menu.title === "Export" && !this.scanDataDownloadInProgress) {
      this.downloadScandata(menu);
    }
  }

  public downloadScandata(menu) {
    menu.icon = "zmdi zmdi-block";
    this.scanDataDownloadInProgress = true;
    this.tostr.info("Please wait it will take some time to download.");
    //Date should be 10 july as mentioned by Aditya Dutta
    let reportFrom = moment("07-10-2023", "MM-DD-YYYY")
      .startOf("day")
      .toDate()
      .getTime(); //moment().subtract(30,"days").startOf('day').toDate().getTime();
    let reportTo = moment().toDate().getTime();
    this.scanService.getAllScanData(reportFrom, reportTo).subscribe(
      (res) => {
        const dt = new Date();
        const tm = dt.getTime();
        this.scanDataDownloadInProgress = false;
        menu.icon = "zmdi zmdi-download";
        // nafeddata_<Timestamp>
        saveAs(res, "result_" + tm + ".xlsx");
      },
      (err) => {
        this.scanDataDownloadInProgress = false;
        menu.icon = "zmdi zmdi-download";
      }
    );
  }

  // public downloadScandata() {
  //     this.tostr.info('Please wait it will take some time to download.');
  //     this.scanService.getAllScanData().subscribe(res => {
  //         const dt = new Date();
  //         const tm = dt.getTime();
  //        // nafeddata_<Timestamp>
  //         saveAs(res, 'result_' + tm + '.xlsx');
  //     });
  // }

  private existPermission(userRoles, permission): boolean {
    return userRoles.find((x) => x.toUpperCase() === permission.toUpperCase());
  }

  public setClass(submenu: any, title: string): boolean {
    //[ngClass]="[setClass(menuItem.path , menuItem.title) ? menuItem.class + ' open' : menuItem.class]"
    return submenu.some((menu) => {
      console.log(menu.path.split("/"));
      return title.replace(" ", "").toLowerCase() === menu.path.split("/")[1];
    });
  }

  // menuItem.class === '' ? [menuItem.path] : null
}
